// extracted by mini-css-extract-plugin
export default {"box":"orderFilterPage_box__msSCA","box__content":"orderFilterPage_box__content__dPd2Z"};